var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoalRemainingDays(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.114258,
    width: 32,
    height: 32,
    rx: 6.4,
    fill: "#FFC93E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 6V8M11 6V8",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9955 17H17.0045M16.9955 21H17.0045M20.991 17H21M13 17H13.009M13 21H13.009",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12H25.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16.2432C7.5 11.8859 7.5 9.70728 8.75212 8.35364C10.0042 7 12.0195 7 16.05 7H17.95C21.9805 7 23.9958 7 25.2479 8.35364C26.5 9.70728 26.5 11.8859 26.5 16.2432V16.7568C26.5 21.1141 26.5 23.2927 25.2479 24.6464C23.9958 26 21.9805 26 17.95 26H16.05C12.0195 26 10.0042 26 8.75212 24.6464C7.5 23.2927 7.5 21.1141 7.5 16.7568V16.2432Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12H26",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalRemainingDays);
export default __webpack_public_path__ + "static/media/goal-remaining-days.b424d48f72ef9610a5c848bdd8fe1c17.svg";
export { ForwardRef as ReactComponent };